let createConditional = () => {
  let parent = $("[name='stake']")
  let child = $('.unstaked')

  parent.change(() => {
    if (parent.filter(':checked').val() == 0) {
      child.show()
      
      $(".unstaked input.form-control").prop('required', true)
    } else {
      child.hide()

      $(".unstaked input.form-control").prop('required', false)
    }
  })
}

let updateForm = () => {
  $("[name='stake']").change()
}

$(() => {
  createConditional()
  updateForm()
})